// Helper Imports
import { formatDate } from "../../../../../Helpers/formatters";

// MUI Imports
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const CustomerLockoutsBody = ({ lockoutData, setTrigger, userId, role }) => {
  const isAdminOrSuperUser = role === "Administrator" || role === "Super User" || role === "Supervisor"; 

  const clearLockout = async (id) => {
    const options = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await fetch(`/api/customer/${id}/update-lockout?userId=${userId}`, options);
    const { success, message } = await res.json();
    
    setTrigger("UPDATE_LOCKOUT");
  };

  return (
    <TableBody>
      {lockoutData.map((row, index) => {
        const {id, lockoutTriggered, lockoutExpired, lockoutType, clearedByUser} = row;
        return (
          <TableRow key={index}>
            <TableCell className="tableCell" align="center">
              {formatDate(lockoutTriggered)}
            </TableCell>
            <TableCell className="tableCell" align="center">
              {formatDate(lockoutExpired)}
            </TableCell>
            <TableCell className="tableCell" align="center">
              {lockoutType}
            </TableCell>
            <TableCell className="tableCell" align="center">
              {clearedByUser}
            </TableCell>           
            <TableCell className="tableCell" align="center">
              { isAdminOrSuperUser &&
                <button
                  onClick={() => {clearLockout(id);}}
                  className="update-lockout-btn"
                >
                  <span>Clear Lockout</span>
                </button>
              }
            </TableCell>       
          </TableRow>
        );
      })}
    </TableBody>
  );
};

export default CustomerLockoutsBody;
